module.exports = __webpack_public_path__ + "img/win_bg.48615705.png";